var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigVersionDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333374 6.99968C0.333374 3.31301 3.31337 0.333008 7.00004 0.333008C10.6867 0.333008 13.6667 3.31301 13.6667 6.99968C13.6667 10.6863 10.6867 13.6663 7.00004 13.6663C3.31337 13.6663 0.333374 10.6863 0.333374 6.99968ZM8.9267 9.86642C9.1867 10.1264 9.6067 10.1264 9.8667 9.86642C10.12 9.60642 10.12 9.17975 9.8667 8.92642L7.94003 6.99975L9.8667 5.07309C10.1267 4.81309 10.1267 4.39309 9.8667 4.13309C9.6067 3.87309 9.1867 3.87309 8.9267 4.13309L7.00003 6.05975L5.07336 4.13309C4.81336 3.87309 4.39336 3.87309 4.13336 4.13309C4.00853 4.25764 3.93837 4.42674 3.93837 4.60309C3.93837 4.77943 4.00853 4.94853 4.13336 5.07309L6.06003 6.99975L4.13336 8.92642C4.00853 9.05097 3.93837 9.22007 3.93837 9.39642C3.93837 9.57276 4.00853 9.74186 4.13336 9.86642C4.39336 10.1264 4.81336 10.1264 5.07336 9.86642L7.00003 7.93975L8.9267 9.86642Z",
    fill: "#5A87EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigVersionDelete);
export default __webpack_public_path__ + "static/media/jobconfig-version-delete.5a3eeb3da9c8017a6c033b81957a79f7.svg";
export { ForwardRef as ReactComponent };